module.exports = __webpack_public_path__ + "static/media/menu_quit.c0a9a25e.svg";